export default {
  'open-menu': 'Open het menu',
  'close-menu': 'Sluit',
  'editorial-staff': 'Redactie',
  about: 'Over ons',
  shopLink: 'Een wereld van mogelijkheden',
}
